/* global axios */
import ApiClient from './ApiClient';

class BlogPostsAPI extends ApiClient {
  constructor() {
    super('blog_posts', { accountScoped: true });
  }

  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }

  unpublish(id) {
    return axios.post(`${this.url}/${id}/unpublish`);
  }
}

export default new BlogPostsAPI();
